import script from "./PlatformGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformGrid.vue?vue&type=script&setup=true&lang=ts"

import "./PlatformGrid.vue?vue&type=style&index=0&id=7c1d94cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1d94cc"]])

export default __exports__